import { produce } from 'immer'
import { IShowGuide } from './types'

const INITIAL_STATE = {
  showHomeGuide: true,
}

export default function user(state: IShowGuide = INITIAL_STATE, action): any {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@showGuide/CHANGE_HOMEGUIDE': {
        draft.showHomeGuide = action.payload
        break
      }

      default:
    }
  })
}
